<template>
  <v-dialog v-model="dialogStatus" width="400">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex
            xs10
            sm10
            md10
            lg10
            class="headline"
          >{{ $t('rms_share_invitation_dialog_box_header') }}</v-flex>
          <v-flex xs2 sm2 md2 lg2 class="text-xs-right">
            <v-btn small dark color="red" icon @click="dialogStatus = false">
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class>
        <div class>
          <social-sharing
            :url="getUrl(link.id)"
            :title="$t('rms_avail_link_share_title')"
            :description="$t('rms_avail_link_share_description', {invitee: link.created_for_name})"
            inline-template
            :networks="overriddenNetworks"
          >
            <div>
              <network network="sms" v-if="isMobile">
                <i class="mdi mdi-message-bulleted display-1 mx-2 blue"></i>
              </network>
              <network network="linkedin">
                <i class="mdi mdi-linkedin-box display-1 mx-2 blue--text"></i>
              </network>
              <network network="skype">
                <i class="mdi mdi-skype display-1 blue--text mx-2"></i>
              </network>
              <network network="whatsapp" v-if="isMobile">
                <i class="mdi mdi-whatsapp green--text display-1 mx-2"></i>
              </network>
              <network network="custom">
                <i class="mdi mdi-email display-1 red--text mx-2"></i>
              </network>
              <network network="facebook">
                <i class="mdi mdi-facebook-box display-1 indigo--text mx-2"></i>
              </network>
              <network network="twitter">
                <i class="mdi mdi-twitter-box display-1 mx-2 blue--text"></i>
              </network>
            </div>
          </social-sharing>
        </div>
        <div class="mt-4">
          <div class="body-2 font-weight-bold">{{ $t('rms_manually_share_label') }}</div>
          <v-layout row wrap class="mt-4">
            <v-flex xs12 sm12 md12 lg12 class="text-truncate mt-2 body-1">{{ getUrl(link.id) }}</v-flex>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          block
          class="mt-2"
          color="green"
          v-clipboard:copy="getUrl(link.id)"
          v-clipboard:success="copySuccess"
          v-clipboard:error="copyFail"
        >{{ $t('rms_copy_link_btn_label') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import { mapGetters } from "vuex";
export default {
  props: ["dialog", "link"],
  data() {
    return {
      overriddenNetworks: {
        custom: {
          sharer: "mailto:?subject=@title&body=@description%0D%0A%0D%0A@url",
          type: "popup"
        }
      },
      msg: isMobile ? "Mobile screen" : "It is desktop"
    };
  },
  computed: {
    dialogStatus: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    ...mapGetters({
      links: "avails/getActiveLinks",
      selected_company_id: "company/getSelected"
    })
  },
  methods: {
    copySuccess: function() {
      this.$store.dispatch("availLink/copySuccess");
    },
    copyFail: function() {
      this.$store.dispatch("availLink/copyFail");
    },
    getUrl(uuid) {
      return this.$store.getters["availLink/getUrl"]({
        uuid: uuid,
        company_id: this.selected_company_id
      });
    }
  }
};
</script>

<style></style>
